/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Section_HistoryInputs */

const en_admin_funnel_section_history = /** @type {(inputs: Admin_Funnel_Section_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traffic since launch (Cloudflare Web Analytics + orders)`)
};

/**
* | output |
* | --- |
* | "Traffic since launch (Cloudflare Web Analytics + orders)" |
*
* @param {Admin_Funnel_Section_HistoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_section_history = /** @type {((inputs?: Admin_Funnel_Section_HistoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Section_HistoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_section_history(inputs)
});
export { admin_funnel_section_history as "admin.funnel.section.history" }